import { useState } from "react";
import { VeiculoEletricoInputCard } from "./components/VeiculoEletricoInputCard";
import { VeiculoEletricoResponse } from "./components/VeiculoEletricoResponse";
import type { ResultsType } from "./calculadora-veiculo-eletrico_d";

export default function VeiculoEletrico() {
  const [results, setResults] = useState<ResultsType | null>(null);

  return (
    <>
      <VeiculoEletricoInputCard setResults={setResults} />
      {results && <VeiculoEletricoResponse results={results} />}
    </>
  );
}